export interface AbortResult {
  saved: boolean;
  state: string;
}
